 import React, { useEffect, useState, useRef } from "react";
import { WebService } from "../../Services/WebService";
import ApproveRejectRegularization from "./ApproveRejectRegularization";
import BulkActionModal from "./BulkActionModal"; // Import the new modal
import Container from "react-bootstrap/Container";
import { useDispatch, useSelector } from "react-redux";
import TableComponent from "../../Services/TableComponent";
import { ActionPermission, PageInfo } from "../PageInfo";
import SnackbarComponent from "../../Services/SnackbarComponent";
import DeleteConfirmAlert from "../../Services/AlertComponent";
import ActionButton from "../../Services/ActionButton";
import { NoRecordTemplate } from "../../Services/TableComponent";
import { StandardConst } from "../../Services/StandardConst";
import { Box, Checkbox } from "@mui/material";
import BreadcrumbsComponent from "../../Services/BreadcrumbsComponent";
import { chain, map , sortBy } from "underscore";
import { useSearchParams } from "react-router-dom";
import { DateTime } from "luxon";
import Button from "react-bootstrap/Button";
import { WSSuccessAlert } from "../../Services/WSAlert";
import { addDays } from "date-fns";


const AttendanceRegularizationApproval = () => {
  const [searchParams] = useSearchParams();
  const ref = useRef();
  const refSnackbar = useRef();
  const [records, setRecords] = useState([]);
  const [selectedRequests, setSelectedRequests] = useState([]);
  const dispatch = useDispatch();
  const [currentDate] = useState({ FromDate: DateTime.now().toFormat('yyyy-MM-dd') });
  
  // Bulk action modal state
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkActionType, setBulkActionType] = useState(""); // "approve" or "reject"

  const loggedUser = useSelector((s) => s.auth.LoggedUser ?? 0);
      const childUser = useSelector((s) => s.auth.ChildUsers ?? []);

  PageInfo({ pageTitle: "Approve Attendance Regularization" });
console.log(loggedUser,'all emp data');
console.log(childUser,'all child emp data');

  const [permission, SetPermission] = useState({});
  const permissionList = useSelector((s) => s.auth.PermissionList ?? []);
  const getLogedin = useSelector((s) => s.auth?.BasicInfo ?? []);
  const myEmployeeId = getLogedin?.EmployeeId || 0;
  useEffect(() => {
    SetPermission({
      ManageAllUser: ActionPermission("Attendance - Search All User"),
      ManageApproveReject: ActionPermission("Attendance - Approve Reject"),
    });
  }, [permissionList]);
  
  console.log('my self login,',getLogedin);

  const [persons, setPersons] = useState([]);

 
// SOLUTION 1: Simplify the persons array structure
// Update fetchPersonList function to ensure consistent data structure

const fetchPersonList = async () => {
  let res = await WebService({
    endPoint: `Visitor/fetchAllEmployees`,
  })
    .then((r) => sortBy(r, "FullName"))
    .then((r) =>
      map(r, (m) => ({
        EmployeeId: m.EmployeeId,
        heading: m.FullName,
        description: m.Designation,
        avatar: `${StandardConst.apiBaseUrl}/uploads/${m.ProfileImage}`,
        text: m.FullName,
        value: m.EmployeeId,
      }))
    );

  const listOfUser = childUser.concat([loggedUser]);
  res = res.filter((f) => listOfUser.includes(f.value));
  
  setPersons([
    // { 
    //   EmployeeId: 0, 
    //   heading: "All Person", 
    //   value: 0,
    //   text: "All Person",
    //   description: "",
    //   avatar: ""
    // }
  ].concat(res));
};



// SOLUTION 2: Update filterData configuration
// In your TableComponent, use this exact configuration:



  useEffect(() => {
      fetchPersonList();
  }, [loggedUser, childUser]);


  // const fetchRegularizationList = async (filters) => {
  //   console.log("🔍 Fetching with filters:", filters);
    
  //   const dateObj = filters.FromDate 
  //     ? new Date(filters.FromDate)
  //     : new Date();
  //   const month = dateObj.getMonth() + 1;
  //   const year = dateObj.getFullYear();


    
  //   console.log(`📅 Fetching data for Month: ${month}, Year: ${year}`);

  //   const childUsers = await WebService({ dispatch, endPoint: "User/LoggedUser" }).then((r) => {
  //     let resp;
  //     if ((r.EmployeeId ?? 0) !== 0) {
  //       resp = WebService({ dispatch, endPoint: `User/ChildUsers/${r.EmployeeId}` }).then((cu) => {
  //         return cu;
  //       });
  //     }
  //     return resp;
  //   });

  //    const CompanyData =  await WebService({
  //         dispatch,
  //         endPoint: `Officelocation/getContactForOfficeLocation`,
  //       }).then((r) => {
  //       return r;
  //         // setContactUs(r);
  //       });

  //   const manageAllUser = ActionPermission("Attendance - Search All User");
  //   const endPoint = `AttendanceRegularization/Fetch/AllRequests`;
  //   const data = await WebService({ endPoint, dispatch, body: { Date: { month, year } } })
  //     .then((r) =>
  //       map(r, (m) => {
  //         console.log("📅 Raw AttendanceDates:", m);
  //         m.EncodedId = window.btoa(m.RegularizationId);
          
  //         m.AttendanceDateFormatted = m.AttendanceDate 
  //           ? DateTime.fromISO(m.AttendanceDate).toFormat("dd-MM-yyyy") 
  //           : "-";
          
  //         m.OriginalTimeFormatted = m.OriginalInTime && m.OriginalOutTime
  //           ? `${DateTime.fromISO(m.OriginalInTime).toFormat("hh:mm a")} - ${DateTime.fromSQL(m.OriginalOutTime).toFormat("hh:mm a")}`
  //           : "-";
          
  //         m.RequestedTimeFormatted = m.CorrectedInTime && m.CorrectedOutTime
  //           ? `${DateTime.fromISO(m.CorrectedInTime).toFormat("hh:mm a")} - ${DateTime.fromSQL(m.CorrectedOutTime).toFormat("hh:mm a")}`
  //           : "-";
          
  //         m.StatusText = getStatusText(m.StatusId);
          
  //         return m;
  //       })
  //     )
  //     .then((r) => {
  //       let filtered = r.filter((f) => f.StatusId !== 4);

  //       // if (!manageAllUser) {
  //       //   filtered = filtered.filter((f) => childUsers.includes(f.EmployeeId));
  //       // }

        
  //         // ✅ Include special condition
  //         filtered = filtered.filter((f) => {
  //           const approverMissing = f.ApproverId === null || f.ApproverId === 0;
  //           const sameEmployee = f.EmployeeId === myEmployeeId; // <-- replace `myId` with your actual variable
  //         console.log(CompanyData , 'COMPANY DATA ---->')
  //         const employeeIds = CompanyData.map(emp => emp.EmployeeDetail?.EmployeeId || emp.EmployeeId);
  //         console.log('company core emplyee',employeeIds); // [852, 919]

  //         const isAvailable = employeeIds.includes(myEmployeeId);
  //           // Keep if:
  //           // - manageAllUser = true (no restriction), or
  //           // - EmployeeId is in childUsers, or
  //           // - ApproverId is null/0 AND EmployeeId = myId
  //           // - myEmployeeId is admin or HR
  //           return (
  //             manageAllUser ||
  //             childUsers.includes(f.EmployeeId) ||
  //             (approverMissing && sameEmployee) || isAvailable
  //           );
  //         });
  //       console.log(`✅ Total records fetched: ${filtered.length}`);
  //       return filtered;
  //     });
  //   console.log('final Data----->',data);
  //   setRecords(data);
  // };




// STEP 1: Add status options state in your component (add this with other useState)
const [statusOptions] = useState([
  // { value: 0, text: "All Status", heading: "All Status" },
  { value: StandardConst.RegulrizationStatus.Pending, text: "Pending", heading: "Pending" },
  { value: StandardConst.RegulrizationStatus.Approved, text: "Approved", heading: "Approved" },
  { value: StandardConst.RegulrizationStatus.Rejected, text: "Rejected", heading: "Rejected" },
  // Add Cancelled if needed
  // { value: StandardConst.RegulrizationStatus.Cancelled, text: "Cancelled", heading: "Cancelled" },
]);

const [requestTypeOptions] = useState([
  // { value: 0, text: "All Request Types", heading: "All Request Types" },
  { value: 1, text: "Missed Punch", heading: "Missed Punch" },
  { value: 2, text: "Incorrect Punch", heading: "Incorrect Punch" },
  { value: 3, text: "On Duty", heading: "On Duty" },
  { value: 4, text: "Work from Home", heading: "Work from Home" },
  { value: 5, text: "Other", heading: "Other" },
]);
// STEP 1: Add this helper function ABOVE fetchRegularizationList
// This is NEW and doesn't affect anything else
const getRequestTypeIdFromName = (name) => {
  const mapping = {
    "Missed Punch": 1,
    "Incorrect Punch": 2,
    "On Duty": 3,
    "Work from Home": 4,
    "Other": 5,
  };
  return mapping[name] || 0;
};


// const fetchRegularizationList = async (filters) => {
//   console.log("🔍 Fetching with filters:", filters);
  
//   const dateObj = filters.FromDate ? new Date(filters.FromDate) : new Date();
//   const month = dateObj.getMonth() + 1;
//   const year = dateObj.getFullYear();
  
//   // Handle EmployeeId from filters
//   let selectedEmployeeId = 0;
  
//   if (filters.EmployeeId !== undefined && filters.EmployeeId !== null) {
//     if (typeof filters.EmployeeId === 'object' && filters.EmployeeId.value !== undefined) {
//       selectedEmployeeId = Number(filters.EmployeeId.value);
//     } else {
//       selectedEmployeeId = Number(filters.EmployeeId);
//     }
//   }
  
//   console.log(`📅 Month: ${month}, Year: ${year}, EmployeeId: ${selectedEmployeeId}`);

//   const childUsers = await WebService({ 
//     dispatch, 
//     endPoint: "User/LoggedUser" 
//   }).then((r) => {
//     let resp;
//     if ((r.EmployeeId ?? 0) !== 0) {
//       resp = WebService({ 
//         dispatch, 
//         endPoint: `User/ChildUsers/${r.EmployeeId}` 
//       }).then((cu) => cu);
//     }
//     return resp;
//   });

//   const CompanyData = await WebService({
//     dispatch,
//     endPoint: `Officelocation/getContactForOfficeLocation`,
//   }).then((r) => r);

//   const manageAllUser = ActionPermission("Attendance - Search All User");
//   const endPoint = `AttendanceRegularization/Fetch/AllRequests`;
  
//   const data = await WebService({
//     endPoint,
//     dispatch,
//     body: { Date: { month, year } }
//   })
//     .then((r) =>
//       map(r, (m) => {
//         m.EncodedId = window.btoa(m.RegularizationId);
//         m.AttendanceDateFormatted = m.AttendanceDate
//           ? DateTime.fromISO(m.AttendanceDate).toFormat("dd-MM-yyyy")
//           : "-";
//         m.OriginalTimeFormatted =
//           m.OriginalInTime && m.OriginalOutTime
//             ? `${DateTime.fromISO(m.OriginalInTime).toFormat("hh:mm a")} - ${DateTime.fromSQL(m.OriginalOutTime).toFormat("hh:mm a")}`
//             : "-";
//         m.RequestedTimeFormatted =
//           m.CorrectedInTime && m.CorrectedOutTime
//             ? `${DateTime.fromISO(m.CorrectedInTime).toFormat("hh:mm a")} - ${DateTime.fromSQL(m.CorrectedOutTime).toFormat("hh:mm a")}`
//             : "-";
//         m.StatusText = getStatusText(m.StatusId);
//         return m;
//       })
//     )
//     .then((r) => {
//       console.log("📊 Total records:", r.length);
      
//       let filtered = r.filter((f) => f.StatusId !== 4);

//       filtered = filtered.filter((f) => {
//         const approverMissing = f.ApproverId === null || f.ApproverId === 0;
//         const sameEmployee = f.EmployeeId === myEmployeeId;
        
//         const employeeIds = CompanyData.map(emp => 
//           emp.EmployeeDetail?.EmployeeId || emp.EmployeeId
//         );
//         const isAvailable = employeeIds.includes(myEmployeeId);

//         const passesPermissionCheck = (
//           manageAllUser ||
//           childUsers.includes(f.EmployeeId) ||
//           (approverMissing && sameEmployee) ||
//           isAvailable
//         );

//         const passesEmployeeFilter = 
//           selectedEmployeeId === 0 || 
//           f.EmployeeId === selectedEmployeeId;

//         return passesPermissionCheck && passesEmployeeFilter;
//       });

//       console.log(`✅ Filtered: ${filtered.length} records`);
//       return filtered;
//     });

//   setRecords(data);
// };


// 2. UPDATED filterData configuration in TableComponent
// Replace your filterData prop with this:



// STEP 2: Update fetchRegularizationList function to handle Status filter
// const fetchRegularizationList = async (filters) => {
//   console.log("🔍 Fetching with filters:", filters);
  
//   const dateObj = filters.FromDate ? new Date(filters.FromDate) : new Date();
//   const month = dateObj.getMonth() + 1;
//   const year = dateObj.getFullYear();
  
//   // Handle EmployeeId from filters
//   let selectedEmployeeId = 0;
//   if (filters.EmployeeId !== undefined && filters.EmployeeId !== null) {
//     if (typeof filters.EmployeeId === 'object' && filters.EmployeeId.value !== undefined) {
//       selectedEmployeeId = Number(filters.EmployeeId.value);
//     } else {
//       selectedEmployeeId = Number(filters.EmployeeId);
//     }
//   }
  
//   // ✅ NEW: Handle StatusId from filters
//   let selectedStatusId = 0;
//   if (filters.StatusId !== undefined && filters.StatusId !== null) {
//     if (typeof filters.StatusId === 'object' && filters.StatusId.value !== undefined) {
//       selectedStatusId = Number(filters.StatusId.value);
//     } else {
//       selectedStatusId = Number(filters.StatusId);
//     }
//   }
  
//   console.log(`📅 Month: ${month}, Year: ${year}, EmployeeId: ${selectedEmployeeId}, StatusId: ${selectedStatusId}`);

//   const childUsers = await WebService({ 
//     dispatch, 
//     endPoint: "User/LoggedUser" 
//   }).then((r) => {
//     let resp;
//     if ((r.EmployeeId ?? 0) !== 0) {
//       resp = WebService({ 
//         dispatch, 
//         endPoint: `User/ChildUsers/${r.EmployeeId}` 
//       }).then((cu) => cu);
//     }
//     return resp;
//   });

//   const CompanyData = await WebService({
//     dispatch,
//     endPoint: `Officelocation/getContactForOfficeLocation`,
//   }).then((r) => r);

//   const manageAllUser = ActionPermission("Attendance - Search All User");
//   const endPoint = `AttendanceRegularization/Fetch/AllRequests`;
  
//   const data = await WebService({
//     endPoint,
//     dispatch,
//     body: { Date: { month, year } }
//   })
//     .then((r) =>
//       map(r, (m) => {
//         m.EncodedId = window.btoa(m.RegularizationId);
//         m.AttendanceDateFormatted = m.AttendanceDate
//           ? DateTime.fromISO(m.AttendanceDate).toFormat("dd-MM-yyyy")
//           : "-";
//         m.OriginalTimeFormatted =
//           m.OriginalInTime && m.OriginalOutTime
//             ? `${DateTime.fromISO(m.OriginalInTime).toFormat("hh:mm a")} - ${DateTime.fromSQL(m.OriginalOutTime).toFormat("hh:mm a")}`
//             : "-";
//         m.RequestedTimeFormatted =
//           m.CorrectedInTime && m.CorrectedOutTime
//             ? `${DateTime.fromISO(m.CorrectedInTime).toFormat("hh:mm a")} - ${DateTime.fromSQL(m.CorrectedOutTime).toFormat("hh:mm a")}`
//             : "-";
//         m.StatusText = getStatusText(m.StatusId);
//         return m;
//       })
//     )
//     .then((r) => {
//       console.log("📊 Total records:", r.length);
      
//       // Don't filter out cancelled status here - let user choose via dropdown
//       let filtered = r.filter((f) => f.StatusId !== 4);

//       filtered = filtered.filter((f) => {
//         const approverMissing = f.ApproverId === null || f.ApproverId === 0;
//         const sameEmployee = f.EmployeeId === myEmployeeId;
        
//         const employeeIds = CompanyData.map(emp => 
//           emp.EmployeeDetail?.EmployeeId || emp.EmployeeId
//         );
//         const isAvailable = employeeIds.includes(myEmployeeId);

//         // Permission check
//         const passesPermissionCheck = (
//           manageAllUser ||
//           childUsers.includes(f.EmployeeId) ||
//           (approverMissing && sameEmployee) ||
//           isAvailable
//         );

//         // Employee filter
//         const passesEmployeeFilter = 
//           selectedEmployeeId === 0 || 
//           f.EmployeeId === selectedEmployeeId;

//         // ✅ NEW: Status filter
//         const passesStatusFilter = 
//           selectedStatusId === 0 || 
//           f.StatusId === selectedStatusId;

//         return passesPermissionCheck && passesEmployeeFilter && passesStatusFilter;
//       });

//       console.log(`✅ Filtered: ${filtered.length} records (StatusId: ${selectedStatusId})`);
//       return filtered;
//     });

//   setRecords(data);
// };



// 2. Replace your fetchRegularizationList function with this
const fetchRegularizationList = async (filters) => {
  console.log("🔍 Fetching with filters:", filters);
  
  const dateObj = filters.FromDate ? new Date(filters.FromDate) : new Date();
  const month = dateObj.getMonth() + 1;
  const year = dateObj.getFullYear();
  
  // ✅ EXISTING: Handle EmployeeId from filters
  let selectedEmployeeId = 0;
  if (filters.EmployeeId !== undefined && filters.EmployeeId !== null) {
    if (typeof filters.EmployeeId === 'object' && filters.EmployeeId.value !== undefined) {
      selectedEmployeeId = Number(filters.EmployeeId.value);
    } else {
      selectedEmployeeId = Number(filters.EmployeeId);
    }
  }
  
  // ✅ EXISTING: Handle StatusId from filters
  let selectedStatusId = 0;
  if (filters.StatusId !== undefined && filters.StatusId !== null) {
    if (typeof filters.StatusId === 'object' && filters.StatusId.value !== undefined) {
      selectedStatusId = Number(filters.StatusId.value);
    } else {
      selectedStatusId = Number(filters.StatusId);
    }
  }
  
  // ✅ NEW (but safe): Handle RequestTypeId from filters
  let selectedRequestTypeId = 0;
  if (filters.RequestTypeId !== undefined && filters.RequestTypeId !== null) {
    if (typeof filters.RequestTypeId === 'object' && filters.RequestTypeId.value !== undefined) {
      selectedRequestTypeId = Number(filters.RequestTypeId.value);
    } else {
      selectedRequestTypeId = Number(filters.RequestTypeId);
    }
  }
  
  console.log(`📅 Month: ${month}, Year: ${year}`);
  console.log(`👤 EmployeeId: ${selectedEmployeeId}`);
  console.log(`📊 StatusId: ${selectedStatusId}`);
  console.log(`📝 RequestTypeId: ${selectedRequestTypeId}`);

  // ✅ EXISTING: Fetch child users - UNCHANGED
  const childUsers = await WebService({ 
    dispatch, 
    endPoint: "User/LoggedUser" 
  }).then((r) => {
    let resp;
    if ((r.EmployeeId ?? 0) !== 0) {
      resp = WebService({ 
        dispatch, 
        endPoint: `User/ChildUsers/${r.EmployeeId}` 
      }).then((cu) => cu);
    }
    return resp;
  });

  // ✅ EXISTING: Fetch company data - UNCHANGED
  const CompanyData = await WebService({
    dispatch,
    endPoint: `Officelocation/getContactForOfficeLocation`,
  }).then((r) => r);

  // ✅ EXISTING: Permission check - UNCHANGED
  const manageAllUser = ActionPermission("Attendance - Search All User");
  const endPoint = `AttendanceRegularization/Fetch/AllRequests`;
  
  const data = await WebService({
    endPoint,
    dispatch,
    body: { Date: { month, year } }
  })
    .then((r) =>
      map(r, (m) => {
        // ✅ EXISTING: All formatting logic - UNCHANGED
        m.EncodedId = window.btoa(m.RegularizationId);
        m.AttendanceDateFormatted = m.AttendanceDate
          ? DateTime.fromISO(m.AttendanceDate).toFormat("dd-MM-yyyy")
          : "-";
        m.OriginalTimeFormatted =
          m.OriginalInTime && m.OriginalOutTime
            ? `${DateTime.fromISO(m.OriginalInTime).toFormat("hh:mm a")} - ${DateTime.fromSQL(m.OriginalOutTime).toFormat("hh:mm a")}`
            : "-";
        m.RequestedTimeFormatted =
          m.CorrectedInTime && m.CorrectedOutTime
            ? `${DateTime.fromISO(m.CorrectedInTime).toFormat("hh:mm a")} - ${DateTime.fromSQL(m.CorrectedOutTime).toFormat("hh:mm a")}`
            : "-";
        m.StatusText = getStatusText(m.StatusId);
        
        // ✅ NEW (but safe): Only adds RequestTypeId if it doesn't exist
        // If RequestTypeId already exists in data, it won't overwrite it
        if (!m.RequestTypeId && m.RequestTypeName) {
          m.RequestTypeId = getRequestTypeIdFromName(m.RequestTypeName);
        }
        
        return m;
      })
    )
    .then((r) => {
      console.log("📊 Total records:", r.length);

     
      
      // ✅ EXISTING: Filter cancelled - UNCHANGED
      let filtered = r.filter((f) => f.StatusId !== 4);

       console.log('all data for manager HR',filtered);

      // ✅ EXISTING: All permission and filter logic - UNCHANGED
      filtered = filtered.filter((f) => {
        const approverMissing = f.ApproverId === null || f.ApproverId === 0;
        const sameEmployee = f.EmployeeId === myEmployeeId;
        
        const employeeIds = CompanyData.map(emp => 
          emp.EmployeeDetail?.EmployeeId || emp.EmployeeId
        );
        const isAvailable = employeeIds.includes(myEmployeeId);

        // ✅ EXISTING: Permission check - UNCHANGED
        const passesPermissionCheck = (
          manageAllUser ||
          childUsers.includes(f.EmployeeId) ||
          (approverMissing && sameEmployee) ||
          isAvailable
        );

        // ✅ EXISTING: Employee filter - UNCHANGED
        const passesEmployeeFilter = 
          selectedEmployeeId === 0 || 
          f.EmployeeId === selectedEmployeeId;

        // ✅ EXISTING: Status filter - UNCHANGED
        const passesStatusFilter = 
          selectedStatusId === 0 || 
          f.StatusId === selectedStatusId;

        // ✅ NEW (but safe): Request Type filter
        // When selectedRequestTypeId = 0, this always returns true (shows all)
        // So if filter is not used, it doesn't affect results
        const passesRequestTypeFilter = 
          selectedRequestTypeId === 0 || 
          f.RequestTypeId === selectedRequestTypeId;

        // ✅ EXISTING: Return combined filters
        // Just added && passesRequestTypeFilter at the end
        return passesPermissionCheck && 
               passesEmployeeFilter && 
               passesStatusFilter && 
               passesRequestTypeFilter;
      });

      console.log(`✅ Filtered: ${filtered.length} records`);
      return filtered;
    });

  // ✅ EXISTING: Set records - UNCHANGED
  setRecords(data);
};

  const onDelete = async () => {
    await fetchRegularizationList(currentDate);
  };

  const renderAfterCalled = useRef(false);
  const approveRejectModalRef = useRef();

  const fnApproveReject = async (id, mode = "edit") =>
    await approveRejectModalRef.current.openModal(id || 0, mode);

  const handleSelectRequest = (id, checked) => {
    if (checked) {
      setSelectedRequests([...selectedRequests, id]);
    } else {
      setSelectedRequests(selectedRequests.filter((reqId) => reqId !== id));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const pendingIds = records
        .filter((r) => r.StatusId === StandardConst.RegulrizationStatus.Pending)
        .map((r) => r.RegularizationId);
      setSelectedRequests(pendingIds);
    } else {
      setSelectedRequests([]);
    }
  };

  const getStatusText = (statusId) => {
    switch (statusId) {
      case 1:
        return "Pending";
      case 2:
        return "Approved";
      case 3:
        return "Rejected";
      case 4:
        return "Cancelled";
      default:
        return "Unknown";
    }
  };

  // Open bulk action modal
  const handleBulkActionClick = (action) => {
    if (selectedRequests.length === 0) {
      return;
    }
    setBulkActionType(action);
    setShowBulkModal(true);
  };

  // Perform bulk action with remark
  const handleBulkActionConfirm = async (remark) => {
    const statusId = bulkActionType === "approve" 
      ? StandardConst.RegulrizationStatus.Approved 
      : StandardConst.RegulrizationStatus.Rejected;

console.log(records,bulkActionType,'BBLLLKK',selectedRequests,remark);


console.log('KRISHNA',persons);

// const filteredRecords = records.filter((record) =>
//   selectedRequests.includes(record.RegularizationId)
// );
const filteredRecords = records
  .filter((record) => selectedRequests.includes(record.RegularizationId))
  .map((record) => ({
    EmployeeId: record.EmployeeId,
    AttendanceDate: record.AttendanceDate.split("T")[0],
    CorrectedInTime: record.CorrectedInTime,
    CorrectedOutTime: record.CorrectedOutTime,
  }));

  const mailNotify = records
  .filter((record) => selectedRequests.includes(record.RegularizationId))
  .map((record) => ({
    EmployeeId: record.EmployeeId,
  }));
console.log('send mail to this persons', mailNotify);

console.log(filteredRecords,'FILTERDE');



// get all bulk apruve/rejected data
const filteredBulkRecords = records.filter(rec =>
  selectedRequests.includes(rec.RegularizationId)
);



console.log("Filtered Records:", filteredRecords);

    await WebService({
      endPoint: "AttendanceRegularization/BulkAction",
      body: {
        RequestIds: selectedRequests,
        StatusId: statusId,
        ApprovalNote: remark, // Use the remark from modal
      },
      dispatch,
    });

    WSSuccessAlert(
      "Success", 
      `${selectedRequests.length} request(s) ${bulkActionType === "approve" ? "approved" : "rejected"} successfully.`
    );

    console.log('Abhishek records 1-->',records);

console.log('Abhishek remark  2-->',remark);

console.log('Abhishek selectedRequests 3-->',selectedRequests);

console.log('Abhishek statusId 4-->', statusId);

    // Bulk notifications
            if(selectedRequests){
          
          //     const dts = new Date(records.AttendanceDate);
          //     const formatted = dts.toISOString().split("T")[0];
    
               
    
            
                // await WebService({
                //   dispatch,
                //   endPoint: "Notification/Create",
                //   body: {
                //     Message: `Your regularization request for ${formatted ? formatted : records.AttendanceDate}`,
                //     SendTo: filteredRecords, // make sure ContactPerson exists in data
                //     Expire: addDays(new Date(), 1),
                //   },
                // });

                const promises = filteredRecords.map(rec =>
                 {
                  console.log('rec AAAAAAAAA',rec);
                  console.log('AAAAAA -----> ',filteredRecords)

                 
                  WebService({
                    dispatch,
                    endPoint: "Notification/Create",
                    body: {
                      Message: `Your regularization request for ${rec.AttendanceDate.split("T")[0]} is ${bulkActionType}`,
                      SendTo:  [rec.EmployeeId],
                      Expire: addDays(new Date(), 1),
                    },
                  })
                }
                );
                await Promise.all(promises); // Execute all together


// alert(bulkActionType);
                // Bulk Appruve reject mail
                await WebService({
                  endPoint: "Email/send-regularization-Bulk-ApprovalEmail",
                  body: {'data':filteredBulkRecords,'staus':bulkActionType,'remark':remark},
                  dispatch,
                });
           }



          



    // ===================MARK ATTENDANCE BULK==================================
     // Send notification only if EmployeeId exists
     console.log(filteredRecords.length,bulkActionType,'CONDITIOND------>');
    if (filteredRecords.length > 0 && bulkActionType === "approve" ) {
      // alert(bulkActionType);
      console.log(bulkActionType,'AGYA IF ME');
      // alert(bulkActionType);
      try {
        const checkInResponse = await WebService({
          endPoint: "AttendanceRegularization/BulkEmployeeAttendance",
          dispatch,
          body: { records: filteredRecords },
        });

        console.log(checkInResponse.Message, "✅ Bulk Attendance Response");
      } catch (error) {
        console.error("❌ Error during bulk attendance:", error);
      }
        
    }
   
        
    // =======================================================


    
    // Close modal and reset state
    setShowBulkModal(false);
    setSelectedRequests([]);
    setBulkActionType("");
    
    // Refresh the list
    fetchRegularizationList(currentDate);
  };

  const getStatusBadge = (statusId) => {
    switch (statusId) {
      case 1:
        return <span className="badge bg-warning">Pending</span>;
      case 2:
        return <span className="badge bg-success">Approved</span>;
      case 3:
        return <span className="badge bg-danger">Rejected</span>;
      case 4:
        return <span className="badge bg-secondary">Cancelled</span>;
      default:
        return <span className="badge bg-info">Unknown</span>;
    }
  };

  const columns = [
    { 
      Text: "EncodedId", 
      Value: "EncodedId", 
      isVisiable: false 
    },
    {
      Text: "",
      cssClass: "text-center",
      Value: "",
      NotUseInExport: true,
      render: (dr) => (
        dr.StatusId === StandardConst.RegulrizationStatus.Pending ? (
          <Checkbox
            checked={selectedRequests.includes(dr.RegularizationId)}
            onChange={(e) => handleSelectRequest(dr.RegularizationId, e.target.checked)}
          />
        ) : null
      ),
    },
    {
      Text: "Employee",
      Value: "EmployeeName",
    },
    {
      Text: "Attendance Date",
      Value: "AttendanceDateFormatted",
    },
    {
      Text: "Request Type",
      Value: "RequestTypeName",
    },
    {
      Text: "Requested Time",
      Value: "RequestedTimeFormatted",
    },
    {
      Text: "Reason",
      Value: "Remarks",
      cssClass: "text-truncate",
      render: (dr) => (
        <span title={dr.Remarks} style={{ maxWidth: "150px", display: "inline-block" }}>
          {dr.Remarks}
        </span>
      ),
    },
    {
      Text: "Approver Remark",
      Value: "ApprovalNote",
      cssClass: "text-truncate",
      render: (dr) => (
        <span title={dr.ApprovalNote} style={{ maxWidth: "150px", display: "inline-block" }}>
          {dr.ApprovalNote || "-"}
        </span>
      ),
    },
    {
      Text: "Status",
      Value: "StatusText",
      render: (dr) => getStatusBadge(dr.StatusId),
    },
    {
      Text: "Action",
      Value: "",
      cssClass: "text-center td-width-150",
      NotUseInExport: true,
      render: (dr) => (
        <div className="d-flex justify-content-center">
          <ActionButton
            onClick={() => fnApproveReject(dr.RegularizationId, "view")}
            IconName="Eye"
            title="View / Edit"
            disabled={
              dr?.StatusId === StandardConst.RegulrizationStatus.Approved || 
              dr?.StatusId === StandardConst.RegulrizationStatus.Rejected
            }
            id={`btnEdit_${dr.RegularizationId}`}
          />

          {dr.StatusId === StandardConst.RegulrizationStatus.Pending && permission.ManageApproveReject && (
            <ActionButton
              onClick={() => fnApproveReject(dr.RegularizationId)}
              IconName="CheckCircle"
              title="Approve / Reject"
              id={`btnApproveReject_${dr.RegularizationId}`}
            />
          )}
        </div>
      ),
    },
  ];

  const [bData] = useState([
    {
      title: "Attendance Management",
      hrefLink: "#",
    },
    {
      title: "Approve Regularization",
      hrefLink: "#",
    },
  ]);

  const MasterPageName = "Approve Attendance Regularization";
  const confirmMessage = MasterPageName + " Deleted successfully";

  return (
    <div className="regu_appruve">
      <SnackbarComponent ref={refSnackbar} confirmMessage={confirmMessage} />
      <DeleteConfirmAlert ref={ref} confirmEvent={(v) => onDelete(v)} />

      {/* Bulk Action Modal */}
      <BulkActionModal
        show={showBulkModal}
        onHide={() => setShowBulkModal(false)}
        onConfirm={handleBulkActionConfirm}
        action={bulkActionType}
        count={selectedRequests.length}
      />

      <div className="base-container">
        <Box sx={{ width: 1 }}>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h3 className="ms-4 mt-2">{MasterPageName}</h3>
              <div className="ms-4">
                <BreadcrumbsComponent bData={bData}></BreadcrumbsComponent>
              </div>
            </div>
            {selectedRequests.length > 0 && (
              <div className="me-4">
                <Button
                  variant="success"
                  size="sm"
                  className="me-2"
                  onClick={() => handleBulkActionClick("approve")}
                >
                  Bulk Approve ({selectedRequests.length})
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleBulkActionClick("reject")}
                >
                  Bulk Reject ({selectedRequests.length})
                </Button>
              </div>
            )}
          </div>
        </Box>

        <TableComponent
          columns={columns}
          data={chain(records)
            .sortBy((s) => s.RegularizationId)
            .reverse()
            .value()}
          title={MasterPageName}
          isSearchRequired={true}
          noRecordCss="p-0"
          excelExportFileName="AttendanceRegularization"
          noRecordFound={
            <NoRecordTemplate
              headerValue="No Regularization Requests Found"
              subHeaderValue="There are no attendance regularization requests to approve"
              imageUrl={StandardConst.imageNoRecordsFound}
            />
          }
          IsAddButtonVisible={false}
          allowSerialNo={true}
          initialSearchContent={searchParams.get("search") ?? ""}
         

// filterData={[
//     {
//       FieldName: "FromDate",
//       DefaultDate: DateTime.local().startOf("month"),
//       FilterType: "MONTH",
//       FilterPlaceholder: "Select Month",
//     },
//     {
//       FieldName: "EmployeeId",
//       FilterType: "DROPDOWN",
//       OptionText: "heading",
//       OptionValue: "value",
//       FilterData: persons,
//       FilterPlaceholder: "Select Employee",
//     },
//     {
//       FieldName: "StatusId",  // ✅ NEW: Status filter
//       FilterType: "DROPDOWN",
//       OptionText: "heading",
//       OptionValue: "value",
//       FilterData: statusOptions,
//       FilterPlaceholder: "Select Status",
//     }
//   ]}

filterData={[
    {
      FieldName: "FromDate",
      DefaultDate: DateTime.local().startOf("month"),
      FilterType: "MONTH",
      FilterPlaceholder: "Select Month",
    },
    {
      FieldName: "EmployeeId",
      FilterType: "DROPDOWN",
      OptionText: "heading",
      OptionValue: "value",
      FilterData: persons,
      DefaultAllValuesText: "All Employee",
      
    },
    {
      FieldName: "StatusId",
      FilterType: "DROPDOWN",
      OptionText: "heading",
      OptionValue: "value",
      FilterData: statusOptions,
      DefaultAllValuesText: "All Status",
      
    },
    {
      FieldName: "RequestTypeId",
      FilterType: "DROPDOWN",
      OptionText: "heading",
      OptionValue: "value",
      FilterData: requestTypeOptions,
      DefaultAllValuesText: "All Request Type",
    }
  ]}
          

          
          callBackEvent={(v) => fetchRegularizationList(v)}
          customHeaderActions={
            <Checkbox
              onChange={(e) => handleSelectAll(e.target.checked)}
              checked={
                selectedRequests.length > 0 &&
                selectedRequests.length ===
                  records.filter((r) => r.StatusId === StandardConst.RegulrizationStatus.Pending).length
              }
            />
          }
        />

        <ApproveRejectRegularization
          callBackEvent={() => fetchRegularizationList(currentDate)}
          ref={approveRejectModalRef}
        />
      </div>
    </div>
  );
};

export default AttendanceRegularizationApproval;